// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicMyHomeV3CreateRealtyRequest,
  TPublicMyHomeV3CreateRealtyModel,
  IMappers,
  TPublicMyHomeV3CreateRealtyResponse,
  IPublicMyHomeV3CreateRealtyResponse,
  IPublicMyHomeV3CreateRealtyResponseError,
} from './types';

export const defaultConfig: TPublicMyHomeV3CreateRealtyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/my-home/v3/create-realty/',
  requestType: 'json',
} as TPublicMyHomeV3CreateRealtyModel;

export function createPublicMyHomeV3CreateRealtyModel(
  parameters: IPublicMyHomeV3CreateRealtyRequest,
): TPublicMyHomeV3CreateRealtyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicMyHomeV3CreateRealtyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicMyHomeV3CreateRealtyRequest;
}

export async function fetchPublicMyHomeV3CreateRealty<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV3CreateRealtyOptions<TResponse200, TResponse400>): Promise<
  TPublicMyHomeV3CreateRealtyResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicMyHomeV3CreateRealtyModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicMyHomeV3CreateRealtyResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicMyHomeV3CreateRealtyResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicMyHomeV3CreateRealtyResponse;
}
